import FacebookRouterAnalytics from './FacebookRouterAnalytics';

export default FacebookRouterAnalytics;
